require("!!/Users/admin/Projects/material-dashboard-angular-master/node_modules/script-loader/addScript.js")(require("!!/Users/admin/Projects/material-dashboard-angular-master/node_modules/raw-loader/index.js!/Users/admin/Projects/material-dashboard-angular-master/node_modules/bootstrap/dist/js/bootstrap.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/dist/js/bootstrap.js
// module id = 264
// module chunks = 2